import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useSwiper } from 'swiper/react'; // eslint-disable-line import/no-unresolved

const SliderScrollbar: React.FC<{ theme?: 'black' | 'white'; className?: string }> = ({
  theme = 'black',
  className,
}) => {
  const swiper = useSwiper();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isEnd, setIsEnd] = useState(false);
  useEffect(() => {
    swiper.on('slideChange', (swiper) => {
      setCurrentIndex(swiper.activeIndex);
      setIsEnd(swiper.isEnd);
    });
  }, [swiper]);
  const cursorRelativeWidth = (100 * swiper.slidesPerViewDynamic()) / swiper.slides.length;
  return (
    <div className={classNames('relative h-1 w-full rounded-full bg-neutrals-black-15', className)}>
      <div
        className={classNames('absolute h-full rounded-full bg-neutrals-black transition-all', {
          'bg-white': theme === 'white',
          'bg-neutrals-black': theme === 'black',
        })}
        style={{
          width: `${cursorRelativeWidth}%`,
          left: isEnd ? `${100 - cursorRelativeWidth}%` : `${(100 * currentIndex) / swiper.slides.length}%`,
        }}
      ></div>
    </div>
  );
};

export default SliderScrollbar;
